import * as Yup from 'yup';

const message =
  'Looks like you might have added sensitive info. Please wait to share that with your pro directly.';
// Keep these patterns in sync with backend/.../referral/validator/ValidNoSensitiveData.kt.
// Digit-adjacency lookaround (not \b) so a match isn't missed when preceded/followed by a
// letter with no separator (e.g. "id123456789"); a non-alphanumeric separator class (not
// just "- ") so dot/underscore-separated variants are caught too.
const forbiddenPatterns: RegExp[] = [
  /(?<!\d)(?!000|666|9\d\d)\d{3}[^A-Za-z0-9]?(?!00)\d{2}[^A-Za-z0-9]?(?!0000)\d{4}(?!\d)/, // SSN
  /(?<!\d)9\d{2}[^A-Za-z0-9]?\d{2}[^A-Za-z0-9]?\d{4}(?!\d)/, // ITIN
  /(?<!\d)\d{2}[^A-Za-z0-9]?\d{7}(?!\d)/, // EIN
  /\b[A-PR-WY][1-9]\d\s?\d{5}[1-9]/ // Passport
];

const sensitiveDataValidation = Yup.string()
  .notRequired()
  .test('no-sensitive-patterns', message, (value) => {
    if (!value) return true;
    return !forbiddenPatterns.some((pattern) => pattern.test(value));
  });

function generateSensitiveDataSchema(field: string) {
  const shape: Record<string, Yup.AnySchema> = {};
  shape[field] = sensitiveDataValidation;
  return Yup.object().shape(shape);
}

export { generateSensitiveDataSchema };
